  <div style="text-align: center;">
    <img style="width: 11%;" src="../../assets/dosyalar/anka-logo.svg">
  </div>    
  <br/><br>
  <h2 style="text-align: center; font-size: x-large; color:#9e141f;"> ANADOLU ÜNİVERSİTESİ İÇ KALİTE GÜVENCESİ DEĞERLENDİRME SİSTEMİ </h2>
  <br/>

  <div class="col-11">
    <ul style="list-style-type: none; font-size: inherit; display: block; text-align: justify;">
        <li>
            Yükseköğretim kurumları; dünyadaki gelişmeleri, Ülkemizin kalkınma planı hedeflerini, Yükseköğretim Kurulu politikalarını, 
            bölgesinin ihtiyaçlarını ve üniversitenin imkânlarını dikkate alarak misyonlarını, vizyonlarını, politikalarını, stratejik amaçlarını ve 
            hedeflerini belirlemektedir. Bu sebeple üniversitelerin kendilerine özgü hedeflerini belirlediği, izlediği ve uygulamaların sonuçlarını
            değerlendirerek sürekli iyileştirdiği bu süreçleri kapsayan iç kalite güvencesi sistemlerini kurmaları yükseköğretim için önemli hâle gelmiştir. 
            Üniversitelerin iç kalite güvencesi sistemlerini kurma faaliyetlerine akademik ve idari çalışanların, öğrencilerin, mezunların ve diğer 
            paydaşların da katkı vermesi, karar alma süreçlerinde yer alması; sürekli iyileşme anlayışının ve kalite kültürünün yerleşmesini ve yayılmasını sağlayacaktır.
        </li><br>
        <li>
            Anadolu Üniversitesi bu amaçlarla, Yükseköğretim Kalite Kurulunun (YÖKAK) ilkelerini de esas alarak yürüttüğü kalite güvencesi sistemi faaliyetlerini, birim 
            iç kalite güvencesi sistemlerinin yapılandırılmasına hız vererek sürdürmektedir. Bu amaçla 2021 yılında ANKA (Kalite Yönetim Sistemi Modülü) oluşturulmuş ve 
            akademik birimlerin kullanımına açılmıştır. ANKA Modülü kullanıcılardan gelen geri bildirimler doğrultusunda sürekli güncellemelerin yapıldığı kullanıcı 
            dostu bir modül olarak tasarlanmıştır.
        </li>
    </ul>
  </div><br>
  <div class="col-2 offset-5" style="text-align: center;">
    <a href="https://kalite.anadolu.edu.tr/" target="_blank" style="width: 100%; background:#9e141f; float: left; padding: 10px; border-radius: 25px; color: white;
    font-size: 15px; position: relative; transition: all .3s; display: inherit; align-items: center;"><i class="fas fa-search"></i>&nbsp;&nbsp;Kalite Sayfası</a>
  </div>


